import { motion } from "framer-motion";
import { ClipboardCheck, Info, FileText, Landmark } from "lucide-react";
import { SectionHeading } from "./FX";

const FEATURES = [
  { icon: ClipboardCheck, title: "Állapotellenőrzés", desc: "A jármű fontosabb műszaki és külső-belső állapotának ellenőrzése a vásárlás előtt." },
  { icon: Info, title: "Átlátható információk", desc: "A rendelkezésre álló fontos információkat egy helyen, érthetően mutatjuk be." },
  { icon: FileText, title: "Dokumentáció", desc: "A rendelkezésre álló járműdokumentumok és adatok gondos áttekintése." },
  { icon: Landmark, title: "Ügyintézés", desc: "A honosítási, műszaki és regisztrációs adó ügyintézés megszervezése és koordinálása." },
];

export const FeatureCarousel = () => (
  <section className="relative py-20 sm:py-32 bg-[#050505] overflow-hidden" data-testid="features-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
      <SectionHeading eyebrow="Az AlpineCar folyamat" title="Amit mi" titleAccent="elintézünk" align="left" />
    </div>

    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
      <div className="flex gap-5 overflow-x-auto pb-6 snap-x snap-mandatory [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden lg:grid lg:grid-cols-4 lg:overflow-visible">
        {FEATURES.map((f, i) => {
          const Icon = f.icon;
          return (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="premium-card shine rounded-3xl p-7 sm:p-8 min-w-[270px] sm:min-w-[300px] lg:min-w-0 snap-start group"
              data-testid={`feature-card-${i}`}
            >
              <div className="w-14 h-14 rounded-2xl bg-[#D4AF37]/10 border border-[#D4AF37]/20 flex items-center justify-center text-[#D4AF37] mb-6 transition-transform duration-300 group-hover:scale-110">
                <Icon className="w-6 h-6" />
              </div>
              <span className="block text-[10px] tracking-[0.3em] uppercase text-white/30 font-bold mb-2">0{i + 1}</span>
              <h3 className="font-display font-bold text-xl text-white mb-3">{f.title}</h3>
              <p className="text-sm text-white/50 leading-relaxed">{f.desc}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
